import { ChangeDetectionStrategy, Component, EventEmitter, NgModule, Output } from '@angular/core';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-training-obligation-phone-number',
  templateUrl: './training-obligation-phone-number.component.html',
  styleUrls: ['./training-obligation-phone-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrainingObligationPhoneNumberComponent {
  @Output() tracker = new EventEmitter<Event>();
}

@NgModule({
  imports: [SharedModule],
  declarations: [TrainingObligationPhoneNumberComponent],
  exports: [TrainingObligationPhoneNumberComponent],
})
export class TrainingObligationPhoneNumberModule {}
